import { defineBlock } from "eddev/blocks"
import { useSnapshot } from "valtio"
import { venueHeader, googleMapsUrl } from "./venue-header"
import { AdminMessage } from "@components/admin/admin-helpers"
import { Mapbox } from "@components/atoms/Mapbox"

export const meta: BlockMeta = {
  title: "Venue Map",
  tags: ["venue"],
}

export default defineBlock("venue/venue-map", () => {
  const props = useSnapshot(venueHeader)

  if (!props.address?.longitude || !props.address?.latitude) {
    if (env.admin) {
      return <AdminMessage>No address has been specified in the venue header, so no map will appear.</AdminMessage>
    } else {
      return null
    }
  }

  return (
    <div className="my-3">
      <Mapbox
        long={props.address.longitude}
        lat={props.address.latitude}
        link={props.address.streetAddress ? googleMapsUrl(props.address.streetAddress) : undefined}
      />
    </div>
  )
})
